import React, { useEffect, useState } from 'react';
import Landing from './pages/Landing';
import Customer from './pages/Customer';

function parseRoute() {
  const parts = window.location.pathname.split('/').filter(Boolean);
  const params = new URLSearchParams(window.location.search);
  if (parts[0] === 'c' && parts[1]) {
    return { name: 'customer', sessionId: parts[1], token: params.get('t') };
  }
  return { name: 'landing' };
}

export default function App() {
  const [route, setRoute] = useState(parseRoute());

  useEffect(() => {
    const onPop = () => setRoute(parseRoute());
    window.addEventListener('popstate', onPop);
    return () => window.removeEventListener('popstate', onPop);
  }, []);

  const goToSession = (sessionId, token) => {
    const url = `/c/${sessionId}${token ? `?t=${encodeURIComponent(token)}` : ''}`;
    window.history.pushState({}, '', url);
    setRoute({ name: 'customer', sessionId, token });
  };

  if (route.name === 'customer') {
    return <Customer sessionId={route.sessionId} token={route.token} />;
  }
  return <Landing onResolved={goToSession} />;
}
